import React from 'react';
import { connect } from 'react-redux';
import Spinner from '../../../../UI/Spinner/Spinner';
import noBaggageImage from './img/no-baggage.png';

import HeadingH4 from '../../../../UI/Headings/HeadingH4/HeadingH4';

const intBaggage = (props) => {
    console.log(props);
    let baggageDataJSX = null;

    baggageDataJSX = <Spinner/>;

    if(props.baggageData) {
        let updatedBaggageData = [...props.baggageData];
        let isSuccess = updatedBaggageData.splice(0,1);
        if(Number(isSuccess[0].success) === 1) {
                const destination = props.cityName[props.flightCode.substring(3, 6)];
                baggageDataJSX =  updatedBaggageData.map((data, index) => {
                    return (
                        <div key={index.toString()} className={`mb-4 u-borderNormal u-flex ${props.isIntRoundTrip ? 'f-column u-height100 u-borderBottomTransparent' : 'f-row u-height90'} justify-content-between phone-f-column u-phone-heightAuto`}>
                            <div className={`pl-4 u-flex ${props.isIntRoundTrip ? 'f-row pl-4 pr-4 pt-1 pb-1 u-borderBottomNormal' : 'f-column pt-1 pb-4'}  justify-content-between phone-f-row phone-pb-2 phone-pl-4 phone-pr-4 u-phone-borderBottomNormal`}>
                                <p className={`u-fontSize13 u-fontWeightMedium u-textColorDark`}>{props.cityNames[data.o]} - {props.cityNames[data.d] ? props.cityNames[data.d] : destination}</p>
                                <p className={`u-textColorDark u-fontSize13 u-fontWeightRegular`}>{props.airlineNames[data.code]}</p>
                            </div>
                            <div className={`u-textColorDark u-fontSize13 u-flex f-column u-phone-borderLeftNone ${props.isIntRoundTrip ? 'u-width100Percent u-height100Percent' : 'u-width490 u-borderLeftNormal'} u-phone-height90 u-phone-widthAuto`}>
                                <div className={`u-flex f-1`}>
                                    <div className={`f-1 u-flex u-borderRightNormal`}></div>
                                    <div className={`f-1 u-fontWeightMedium u-flex justify-content-center align-items-center u-borderRightNormal`}>Adult</div>
                                    <div className={`f-1 u-fontWeightMedium u-flex justify-content-center align-items-center u-borderRightNormal`}>Child</div>
                                    <div className={`f-1 u-fontWeightMedium u-flex justify-content-center align-items-center`}>Infant</div>
                                </div>
                                {
                                    data.baggage.map((baggageData, index) => {
                                        return (
                                            <div className={`u-flex f-1 ${ data.baggage.length === index + 1 ? props.isIntRoundTrip ? 'u-borderBottomNormal' : null : 'u-borderBottomNormal'}`} key={index.toString()}>
                                                <div className={`f-1 u-flex u-fontWeightMedium justify-content-center align-items-center u-borderRightNormal`}>{baggageData.type.charAt(0).toUpperCase() + baggageData.type.slice(1)}</div>
                                                <div className={`f-1 u-flex justify-content-center align-items-center u-borderRightNormal`}>{baggageData.ADT ? baggageData.ADT : '--'}</div>
                                                <div className={`f-1 u-flex justify-content-center align-items-center u-borderRightNormal`}>{baggageData.CHD ? baggageData.CHD : '--'}</div>
                                                <div className={`f-1 u-flex justify-content-center align-items-center`}>{baggageData.INF ? baggageData.INF : '--'}</div>
                                            </div>
                                        );
                                    })
                                }
                            </div>
                        </div>
                    )
                })
        } else {
            baggageDataJSX = <div className={`u-height100Percent u-width100Percent`}>
                <div>
                    <div className={`u-textAlignCenter`}>
                        <img src={noBaggageImage} alt='No Baggage' className={`u-width130`}/>
                    </div>
                    <div className={`mb-2 u-textAlignCenter`}>
                        <HeadingH4 size={20} weight="Medium" color="Dark">No Baggage!</HeadingH4>
                    </div>
                    <p className={`u-fontSize13 u-fontWeightRegular u-textColorNormal u-textAlignCenter`}>Sorry no baggage rules are found for this flight</p>
                </div>
            </div>
        }
    }

    return <div className={`u-minHeight80 u-relative pt-4 pb-4 ${props.isIntRoundTrip ? 'pl-0 pr-0' : 'pl-5 pr-5'}`}>
        {baggageDataJSX}
    </div>;
}

const mapStateToProps = state => {
    return {
        cityNames: state.flights.cityNames,
        cityName: state.flights.cityName,
        airlineNames: state.flights.airlineNames,
        flightCode: state.flights.flightCode,
    } 
}

export default connect(mapStateToProps)(intBaggage);


// WEBPACK FOOTER //
// ./src/components/Flight/Tuple/TupleInner/IntBaggage/IntBaggage.js